// src/components/PrivateRoute.js
import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import IdleTimeoutHandler from "./IdleTimeoutHandler";
import { getCachedTiming, prefetchTiming } from "../utils/attendanceTimingCache";

const PrivateRoute = ({ children }) => {
  const currentUser = localStorage.getItem("currentUser");

  useEffect(() => {
    if (currentUser && !getCachedTiming()) {
      prefetchTiming(); // Prefetch for direct URL / refresh on protected routes
    }
  }, [currentUser]);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return <IdleTimeoutHandler>{children}</IdleTimeoutHandler>;
};

export default PrivateRoute;
